import axios from 'axios';
import Vue from 'vue';


function serviceUrlPack() {
  let url = window.location.host;
  const index = url.indexOf('.');
  url = (index !== -1) ? `${url.substring(0, index)}-pack${url.substring(index, url.length)}` : url;
  return url;
}

function getPackBaseAPIUrl() {
  return `https://${serviceUrlPack()}/api/v1/`;
}

function getPackAPIAxiosInstance() {
  const axiosInstance = axios.create({ baseURL: getPackBaseAPIUrl(),
    timeout: 60000,
  });
  axiosInstance.interceptors.request.use(config => config, error => Promise.reject(error));
  axiosInstance.interceptors.response.use(response => ((response.data) ? response.data : response), error => Promise.reject(error.response));
  return axiosInstance;
}

Vue.prototype.$axiosMieone = getPackAPIAxiosInstance;

export default getPackAPIAxiosInstance;
